/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { GeneralJournalService } from "services/general-journal";

function ActionCell({ item, setDataTable, setPaginationData }) {
  const [open, setOpen] = useState(false);

  const handleDelete = async () => {
    try {
      await GeneralJournalService.deleteS01DnRecord(item.id);
      setDataTable((prev) => ({ ...prev, rows: prev.rows.filter((row) => row.id !== item.id) }));
      setPaginationData((prev) => ({ ...prev, count: Math.max(0, (prev.count || 0) - 1) }));
      toast.success("Xoá sổ S01-DN thành công");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Xoá thất bại");
    } finally {
      setOpen(false);
    }
  };

  return (
    <SoftBox display="flex" alignItems="center">
      <Link to={`/templates/general-journal-ledger/${item.id}/view`}>
        <SoftTypography variant="body1" color="success" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Xem chi tiết" placement="top">
            <Icon>visibility</Icon>
          </Tooltip>
        </SoftTypography>
      </Link>

      <SoftBox mx={2}>
        <SoftTypography
          onClick={() => setOpen(true)}
          variant="body1"
          color="error"
          sx={{ cursor: "pointer", lineHeight: 0 }}
        >
          <Tooltip title="Xóa" placement="left">
            <Icon>delete</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Xóa sổ Nhật ký - Sổ Cái?</DialogTitle>
        <DialogContent>
          <DialogContentText>Bạn có chắc chắn muốn xóa record này?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Hủy</Button>
          <Button onClick={handleDelete} autoFocus>
            Đồng ý
          </Button>
        </DialogActions>
      </Dialog>
    </SoftBox>
  );
}

export default ActionCell;
